import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M8,14.75H9.5a.75.75,0,0,0,0-1.5H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v3a.75.75,0,0,0,1.5,0V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8v2.5a1,1,0,0,0,2,0V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H7.5a1,1,0,0,0,1-1,1,1,0,0,0-.62-.9.23.23,0,0,1-.13-.21V15A.25.25,0,0,1,8,14.75Zm5.75-12.5A.25.25,0,0,1,14,2h3a1,1,0,0,1,1,1V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6Zm-6,0A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25H8A.25.25,0,0,1,7.75,6Zm-1.5,16.5A.25.25,0,0,1,6,19H3a1,1,0,0,1-1-1V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25Zm0-5.75a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8Zm0-7A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2H6a.25.25,0,0,1,.25.25Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.8,13.4a1,1,0,0,0-1.4-.2l-1.88,1.41a8,8,0,0,0-3.71-1c-2.88,0-5.31,1.91-6.51,3.06a2,2,0,0,0,0,2.88A13.35,13.35,0,0,0,12.05,21L10.4,22.2a1,1,0,0,0-.2,1.4,1,1,0,0,0,.8.4,1,1,0,0,0,.6-.2l12-9A1,1,0,0,0,23.8,13.4Zm-10,6.27a11,11,0,0,1-2.08-1.57c1-.93,2.94-2.5,5.12-2.5A5.48,5.48,0,0,1,18.7,16Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.39,16.88a1,1,0,0,0-1.5,1.33.43.43,0,0,1,0,.58A6.55,6.55,0,0,1,17,21a1,1,0,0,0,0,2,8.6,8.6,0,0,0,6.39-2.88,2.46,2.46,0,0,0,0-3.24Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }